"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TransferIcon = function TransferIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.4998 9.99992L16.6665 6.66658L12.4998 3.33325V5.83242H2.49984C2.0396 5.83242 1.6665 6.20551 1.6665 6.66575C1.6665 7.12599 2.0396 7.49908 2.49984 7.49908H12.4998V9.99992ZM18.3332 13.3333C18.3332 12.873 17.9601 12.4999 17.4998 12.4999H7.49984V9.99992L3.33317 13.3333L7.49984 16.6666V14.1666H17.4998C17.9601 14.1666 18.3332 13.7935 18.3332 13.3333Z",
    fill: color
  }));
};

var _default = TransferIcon;
exports.default = _default;